module.exports = __webpack_public_path__ + "img/blue_145.e17c6811.png";